import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import {FournisseurDeLangue} from './i18n/langue';

document.title = 'ASSIMIL Feedback Admin';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <FournisseurDeLangue>
      <App />
    </FournisseurDeLangue>
  </React.StrictMode>
);
